"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var InstagramLoginButton_1 = require("./InstagramLoginButton");
var window_1 = require("./services/window");
var InstagramLoginComponent = (function (_super) {
    __extends(InstagramLoginComponent, _super);
    function InstagramLoginComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.initializeProcess = function () {
            if (window.opener) {
                var _a = window.location.search.match(/.*code=([^&|\n|\t\s]+)/) || [], match = _a[0], code = _a[1];
                console.log("Posting code: ",code)
                window.opener.postMessage({
                    type: "code",
                    data: code
                }, window.origin);
            }
            else {
                var authCallback_1 = _this.props.authCallback;
                window.onmessage = function (_a) {
                    var _b = _a.data, type = _b.type, data = _b.data;
                    if (type === "code") {
                        _this.sendTokenRequest(data)
                            .then(function (res) { return res.text() })
                            .then(function (text) {
                            text = text.replace(/"user_id":\s*(\d+)/,'"user_id":"$1"')
                            data = JSON.parse(text)
                            var popup = _this.state.popup;
                            _this.setState({
                                isCompleted: true
                            }, function () {
                                authCallback_1 && authCallback_1(undefined, data);
                                popup && popup.close();
                            });
                        });
                    }
                };
            }
        };
        _this.buildCodeRequestURL = function () {
            var _a;
            var _b = _this.props, appId = _b.appId, redirectUri = _b.redirectUri, scope = _b.scope;
            var uri = encodeURIComponent(redirectUri || window.location.href);
            return "https://api.instagram.com/oauth/authorize?client_id=" + appId + "&redirect_uri=" + uri + "&scope=" + (((_a = scope) === null || _a === void 0 ? void 0 : _a.join(",")) || "user_profile") + "&response_type=code";
        };
        _this.sendTokenRequest = function (code) {
            var _a = _this.props, appId = _a.appId, appSecret = _a.appSecret, redirectUri = _a.redirectUri;
            var uri = redirectUri || window.location.href;
            var formData = new FormData();
            formData.append("client_id", appId);
            formData.append("client_secret", appSecret);
            formData.append("redirect_uri", uri);
            formData.append("code", code);
            formData.append("grant_type", "authorization_code");
            return fetch("https://api.instagram.com/oauth/access_token", {
                method: "POST",
                body: formData
            });
        };
        _this.handleLoginClick = function () {
            var popup = window_1.openWindow({
                url: _this.buildCodeRequestURL(),
                name: "Log in with Instagram"
            });
            if (popup) {
                window_1.observeWindow({ popup: popup, onClose: _this.handleClosingPopup });
                _this.setState({
                    popup: popup
                });
            }
        };
        _this.handleClosingPopup = function () {
            var authCallback = _this.props.authCallback;
            var isCompleted = _this.state.isCompleted;
            if (!isCompleted) {
                authCallback && authCallback("User closed OAuth popup");
            }
        };
        _this.state = {
            isCompleted: false
        };
        return _this;
    }
    InstagramLoginComponent.prototype.componentDidMount = function () {
        this.initializeProcess();
    };
    InstagramLoginComponent.prototype.render = function () {
        var _a = this.props, buttonTheme = _a.buttonTheme, className = _a.className;
        return (React.createElement(React.Fragment, null,
            React.createElement(InstagramLoginButton_1.default, { buttonTheme: buttonTheme || "gradient", buttonClassName: className, onClick: this.handleLoginClick })));
    };
    return InstagramLoginComponent;
}(React.Component));
exports.default = InstagramLoginComponent;
//# sourceMappingURL=InstagramLogin.js.map